import { log } from '@/log'
import { AuthenticationGateway, AuthStateStore, PreAuthenticationConfig } from '@/services/auth/call-with-auth'

export abstract class BasePreAuthenticationConfig implements PreAuthenticationConfig {
  abstract readonly id: string

  public constructor(
    protected readonly authStateStore: AuthStateStore,
    protected readonly authGateway: AuthenticationGateway,
    protected readonly pageContext: GrowthPalettePageContext
  ) {}

  abstract processable(): boolean
  abstract cascadeOn(error: unknown): boolean
  abstract process(): Promise<void>

  protected onSuccess(message: string) {
    return () => {
      log.info(message)
    }
  }
  protected throwOnFail(message: string) {
    return (error: Error) => {
      log.error({ message, error })

      throw error
    }
  }

}
